import { NotFoundPage } from './pages/NotFoundPage';
import { ImprintPage } from './pages/ImprintPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { SpeechDetails } from './pages/SpeechDetails';
import { CreateSpeech } from './pages/CreateSpeech';
import { Navigate, RouteObject } from 'react-router-dom';

export const routes: RouteObject[] = [
  {
    path: '',
    element: <Navigate to={'wedding'} replace />,
  },
  {
    path: 'wedding',
    element: <CreateSpeech />,
  },
  {
    path: 'speech/:speechId',
    element: <SpeechDetails />,
  },
  {
    path: 'imprint',
    element: <ImprintPage />,
  },
  {
    path: 'privacy',
    element: <PrivacyPage />,
  },
  { path: '*', element: <NotFoundPage /> },
];
